import { features } from '@/mocks/home-data';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-10 md:py-14 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-8">
          平台特色
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="p-6 bg-background-50 border border-background-200/70 rounded-xl text-center"
            >
              <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-2xl bg-primary-100 text-primary-500">
                <i className={`${feature.icon} text-2xl`}></i>
              </div>
              <h3 className="text-base font-bold text-foreground-950 mb-3">{feature.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}